import React from "react";
import { withRouter } from "react-router-dom";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/styles";


const styles = theme => ({
    actionButton: {
        textTransform: "uppercase",
        margin: theme.spacing(1),
        width: 152,
        backgroundColor: "#379aaa"
    },
});

const ExternalLinkBtn = ({ pathTo, classes, icon }) => {

    return (
        <Button
            variant="contained"
            className={classes.actionButton}
            href={pathTo}
            target="_blank" rel="noopener noreferrer"
        >
            {icon}
        </Button>
    );
}

export default withRouter(withStyles(styles)(ExternalLinkBtn));
